<template>
  <div>
    <!-- <h5>Стоимость заказа: {{ order.price_total }} UZS</h5> -->
    <purchases :id="order.id" :order="order" />
    <promotions :order="order" :partner="partner"  />
    <br />
    <Br />

    <div v-if="validate === true">
      <qrcode-stream
        v-if="!result"
        :camera="camera"
        @decode="onDecode"
        @init="onInit"
      />
    </div>
    <div v-else>
      <h3 class="text-danger">
        {{ "order_error" | setText("Заказ не проходит условию") }}
      </h3>
      <h5>
        {{ "min_price_partner" | setText(" Минимальная цена заказа") }}:
        {{ partner.min_price | spaceBetweenNumber }} UZS
      </h5>
      <h5>
        {{ "max_price_partner" | setText(" Максимальная цена заказа") }}:
        {{ partner.max_price | spaceBetweenNumber }} UZS
      </h5>
      <h5>
        {{ "min_qty_partner" | setText("Минимальное количество товаров") }}:
        {{ partner.min_amount_product | spaceBetweenNumber }} шт.
      </h5>
      <h5>
        {{ "max_qty_partner" | setText("Максимальное кличество товаров") }}:
        {{ partner.max_amount_product | spaceBetweenNumber }} шт.
      </h5>
    </div>
  </div>
</template>
<script>
import Purchases from "@/components/Item/Order/Purchases";
import Promotions from "@/components/Item/Order/Promotions";
import { QrcodeStream } from "vue-qrcode-reader";
import { spaceBetweenNumber } from "../../../plugins/filtersTemplate";
import { logger } from "../../../plugins/functions";
export default {
  components: {
    Purchases,
    Promotions,
    QrcodeStream,
  },
  props: {
    partner: {
      default: function () {
        return {};
      },
    },
    createTransaction: {
      default: function () {},
    },
    order: {
      default: function () {
        return {};
      },
    },
    hash: {
      default: null,
    },
    buyer: {
      default: 0,
    },
    index: {
      default: 0,
    },
  },
  name: "filter",
  async created() {},
  computed: {
    validate() {
      if (this.partner.min_amount_product > this.order.quantity_total) {
        return false;
      }
      if (this.partner.max_amount_product < this.order.quantity_total) {
        return false;
      }
      if (this.partner.max_price < this.order.price_total) {
        return false;
      }
      if (this.partner.min_price > this.order.price_total) {
        return false;
      }

      return true;
    },
    products: {
      get() {
        let products = [];
        if (this.order && this.order.purchases && this.order.purchases.length) {
          for (let i = 0; i < this.order.purchases.length; i++) {
            products.push({
              title: this.order.purchases[i]["name"],
              model: this.order.purchases[i]["name"],
              price: this.order.purchases[i]["price"],
              merchant_product_id: this.order.purchases[i]["barcode"],
              serialNumber: this.order.purchases[i]["barcode"],
              count: this.order.purchases[i]["quantity"],
              category: "Смартфоны",
            });
          }
        }
        return products;
      },
    },
  },
  methods: {
    async onDecode(content) {
      this.result = content;
      // this.pause()
      // await this.timeout(500)
      // this.unpause()
    },
    unpause() {
      this.camera = "auto";
    },
    pause() {
      this.camera = "off";
    },
    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (e) {
        // console.error(e)
      } finally {
        this.showScanConfirmation = this.camera === "off";
      }
    },
    next() {
      this.save();
    },
    save() {
      this.$loading(true);

      logger(this.$http, {
        name: "Начал формировать запрос в #IMAN",
        description: "Начало запроса",
        model_type: "order",
        model_id: this.order.id,
        partner_id: this.partner.id,
      });

      this.$http({
        url: `${this.partner["endpoint_url"]}installment/application`,
        method: "POST",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        transformRequest: (data, headers) => {
          delete headers.common["bid"];
          delete headers.common["localization"];
          delete headers.common["shop"];
          delete headers.common["device"];
          delete headers.common["tab"];
          delete headers.common["version"];
          return JSON.stringify({
            qrCode: this.result,
            products: this.products,
          });
        },
      })
        .then((response) => {
          if (response.data && response.data.application_id) {
            this.message = "Создан успешно заказ";
            this.createTransaction({
              exchange_id: response.data.application_id,
              system_confirmed: 1,
              status: 1,
            });
            this.$emit("next", 1);
          } else {
            this.message =
              "Заказ не создан. В результате не пришел application_id";
          }

          if (this.message) {
            this.$notify({
              title: this.partner.name,
              message: this.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });

            logger(this.$http, {
              name: "Начал формировать запрос в #IMAN",
              description: this.message,
              model_type: "order",
              model_id: this.order.id,
            });
          }
        })
        .catch((error) => {
          this.message = "Неизвестная ошибка партнера";

          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            this.message = error.response.data.message;
          } else if (
            error.response.data &&
            (typeof error.response.data === "string" ||
              error.response.data instanceof String)
          ) {
            this.message = error.response.data;
          } else {
            this.message =
              "Невозможно получить данные об ошибке. Платеж не прошел";
          }

          logger(this.$http, {
            name: "Ошибка в иман в #IMAN",
            description: this.message,
            model_type: "order",
            model_id: this.order.id,
          });

          this.$notify({
            title: "IMAN",
            message: this.message,
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
        })
        .finally(() => {
          this.$loading(false);
          setTimeout(() => {
            this.result = null;
          }, 100);
          this.result = null;
        });
    },
  },
  watch: {
    result(val) {
      if (val) {
        this.save(val);
      }
    },
  },
  data() {
    return {
      message: "",
      result: null,
      error: null,
      camera: "auto",
    };
  },
};
</script>
<style lang="scss">
</style>
